import {
  Button,
  Icon,
  Layout,
  PageHeader,
  Table,
  Input,
  Row,
  Col,
  Breadcrumb,
} from "antd";
import React, { Component } from "react";
import { fetchMenuAction } from "../../store/actions/leftSideMenu";
import { connect } from "react-redux";
import "./style.css";
import getColumn from "./column";
import service from "./service";
import offerService from "../OfferManagement/service";
import UpdateSaleOrderModal from "./UpdateSale";

const routes = () => [
  {
    path: "/",
    breadcrumbName: "Home",
  },
  {
    path: "/payment",
    breadcrumbName: "Payment",
  },
  {
    path: "",
    breadcrumbName: "Sale Order",
  },
];

class SaleOrder extends Component {
  state = {
    dataSource: [],
    rows: 0,
    loading: true,
    limit: 10,
    page: 1,

    email: "",
    orderNo: "",

    input_order: "",
    payment_id: 0,
    visibleUpdate: false,
  };

  componentWillMount() {
    this.props.fetchMenuAction("payment", "so");
  }

  async componentDidMount() {
    await this.handleOnFetch(
      this.state.email,
      this.state.orderNo,
      this.state.page
    );
  }

  async handleOnFetch(email, orderNo, page, limit) {
    this.setState({
      loading: true,
    });

    const { total_rows, data } = await service._fetchSaleOrder(
      email,
      orderNo,
      page,
      limit
    );

    this.setState({
      rows: total_rows,
      dataSource: data,
      loading: false,
    });
  }

  async handleOnReset() {
    this.setState({
      email: "",
      orderNo: "",
    });

    await this.handleOnFetch("", "", 1, 10);
  }

  async handleOnPagination({ current }) {
    this.setState({
      page: current,
    });

    await this.handleOnFetch(this.state.email, this.state.orderNo, current, 10);
  }

  triggerModalOnUpdate = (paymentId) => {
    this.setState({
      payment_id: paymentId,
      visibleUpdate: true,
    });
  };

  triggerModalOnClose = () => {
    this.setState({
      input_order: "",
      payment_id: 0,
      visibleUpdate: false,
    });
  };

  async handleOnUpdate(value) {
    this.setState({
      loading: true,
    });

    const payload = {
      id: this.state.payment_id,
      quotation_no: value.order_no,
      invoice_no: value.invoice_no,
    };

    const res = await service._updateSaleOrder(payload);
    offerService.handlerError(res);

    this.triggerModalOnClose();
    await this.handleOnFetch("", "", 1, 10);
  }

  render() {
    const propsTable = {
      className: "my-table",
      columns: getColumn(this.triggerModalOnUpdate),
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        total: this.state.rows,
        showTotal: (total, range) =>
          `Users ${range[0]} - ${range[1]} of ${total}`,
        defaultCurrent: 1,
        defaultPageSize: this.state.limit,
      },
      loading: this.state.loading,
      onChange: (page) => this.handleOnPagination(page),
      bordered: true,
    };

    return (
      <Layout>
        <Breadcrumb className="breadcrumb">
          {routes().map((route, idx) => (
            <Breadcrumb.Item key={idx}>
              {route.path ? (
                <a href={route.path}>{route.breadcrumbName}</a>
              ) : (
                route.breadcrumbName
              )}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
        <PageHeader
          style={{
            backgroundColor: "#f0f2f5",
          }}
          title={<h2 style={{ fontWeight: "bold" }}>Sale Order</h2>}
          extra={[
            <Button
              type="primary"
              onClick={() => this.props.history.push("/so/create")}
            >
              Add
            </Button>,
          ]}
        />
        <div className="my-layout">
          <div className="container">
            <Row
              gutter={10}
              type="flex"
              justify="end"
              style={{ margin: "6px 0px" }}
            >
              <Col span={4}>
                <Input
                  allowClear
                  placeholder="Email"
                  onChange={(e) => this.setState({ email: e.target.value })}
                  value={this.state.email}
                />
              </Col>
              <Col span={4}>
                <Input
                  allowClear
                  placeholder="Order No."
                  onChange={(e) => this.setState({ orderNo: e.target.value })}
                  value={this.state.orderNo}
                />
              </Col>
              <Col span={4} style={{ textAlign: "end" }}>
                <Button
                  onClick={() =>
                    this.handleOnFetch(
                      this.state.email,
                      this.state.orderNo,
                      this.state.page,
                      this.state.limit
                    )
                  }
                >
                  <Icon type="search" />
                </Button>
                <Button onClick={() => this.handleOnReset()}>
                  <Icon type="redo" />
                </Button>
              </Col>
            </Row>

            <div className="table-container">
              <Table {...propsTable} />
            </div>
          </div>
        </div>
        <UpdateSaleOrderModal
          visible={this.state.visibleUpdate}
          onClose={() => this.triggerModalOnClose()}
          onOk={(v) => this.handleOnUpdate(v)}
        />
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headerBarStore: state.headerBar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaleOrder);



// WEBPACK FOOTER //
// ./src/containers/SaleOrder/index.js